//this file contains global constants

//variable for enabling campaign that uses those products
export const delayPaymentCampaignActive = true; //Temporarily it's false, enable once campaign is ready to be used !!!
//list of pnc numbers that are part of delayed payment campaign
export const productsCampaign = [
  "970654312",
  "970653012",
  "970654112",
  "970654412",
  "970745212",
  "970819612",
  "970819712",
  "970819812",
  "970819912",
  "970820012",
  "970820112",
  "970820212",
  "970831012",
  "970831112",
  "970535112",
  "970535212",
  "970535312",
  "970759701",
  "970663201",
  "546258201",
  "970654321",
  "970653021",
  "970654121",
  "970654421",
  "970745221",
  "970819621",
  "970819721",
  "970819821",
  "970819921",
  "970820021",
  "970820121",
  "970820221",
  "970831021",
  "970831121",
  "970535121",
  "970535221",
  "970535321",
  "970862201",
  "970862301",
  "970654303",
  "970653003",
  "970654103",
  "970654403",
  "970745203",
  "970819603",
  "970819703",
  "970819803",
  "970819903",
  "970820003",
  "970820103",
  "970820203",
  "970831003",
  "970831103",
  "970535103",
  "970535203",
  "970535303",
  "970759501",
  "970663301",
  "970759801",
  "970663303",
  "970759803",
  "970871101",
  "970871103",
  "970819630",
  "970819730",
  "970819830",
  "970819930",
  "970820030",
  "970820130",
  "970820230",
];
